module.exports = __webpack_public_path__ + "static/media/1017970.73c4f800.png";